import axios from "axios";
import {settings} from "../config";
import {getTokenService} from "./useTokenService";

export const sendCreateNewBid = async (data: any, user: any) => {
    let {token} = getTokenService({user: user})
    await axios.post(settings.baseUrl + 'AdminBidList/CreateUserBid', {
        isBookNow: data.isBookNow,
        state: data.state,
        city: data.city,
        shipNumber: data.shipNumber,
        ordNumber: data.orderID,
        userId: user.signInDetails.loginId,
        userEmail: user.signInDetails.loginId,
        bidAmount: data.bidRate
    }, {headers: {"Authorization": "Bearer " + token()}})
};